import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_PCP = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_PCP' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <b>Life Domains Assessed during Development of Person-Centered Plan:</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Daily Life and Employment</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Community Living</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtDailyLifeAndEmployment' name='txtDailyLifeAndEmployment' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCommunityLiving' name='txtCommunityLiving' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Safety and Security</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Healthy Living</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSafetyAndSecurity' name='txtSafetyAndSecurity' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtHealthyLiving' name='txtHealthyLiving' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Social and Spirituality</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Citizenship and Advocacy</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSocialAndSpirituality' name='txtSocialAndSpirituality' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCitizenshipAndAdvocacy' name='txtCitizenshipAndAdvocacy' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What do you want to work on? What would you like to accomplish?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtWhatDoYouWantToWorkOnWhatWouldYouLikeAccomplish' name='txtWhatDoYouWantToWorkOnWhatWouldYouLikeAccomplish' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What strengths do you currently have?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtWhatStrengthsDoYouCurrentlyHave' name='txtWhatStrengthsDoYouCurrentlyHave' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What are the obstacles to meeting your goals?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtWhatAreTheObstaclesToMeetingYourGoals' name='txtWhatAreTheObstaclesToMeetingYourGoals' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>ACTION PLAN</b>
                    <span className='small'>The Action Plan section of the PCP includes the individual's long-term goal, short-term goals, interventions, and timeframes.</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Long-Term Goal:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtLongTermGoal' name='txtLongTermGoal' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Short-Term SMART Goal</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Goal:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtGoal' name='txtGoal' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Interventions - Provider (s):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtInterventionsProvider' name='txtInterventionsProvider' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Interventions - Individual and/or Natural Support Actions: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtInterventionsIndividualNaturalSupportActions' name='txtInterventionsIndividualNaturalSupportActions' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <h2>CRISIS PREVENTION AND INTERVENTION PLAN</h2>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Date of Initial Crisis Plan (mm/dd/yyyy): </span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Last Revision (mm/dd/yyyy): </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='date' id='txtDateOfInitialCrisisPlan' name='txtDateOfInitialCrisisPlan' className='add-only' />
                        </td>
                        <td className='w-375'><input type='date' id='txtDateOfLastRevision' name='txtDateOfLastRevision' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Medicaid ID #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Record #:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMedicaidId' name='txtMedicaidId' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtRecord' name='txtRecord' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name :</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Birth </span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Telephone Number:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName' name='txtName' className='add-only' />
                        </td>
                        <td className='w-250'><input type='date' id='txtDateOfInitialCrisisPlan_1' name='txtDateOfInitialCrisisPlan_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTelephoneNumber' name='txtTelephoneNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Clinical Home/First Responder: Carolinas Creative Counseling</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtClinicalHomeFirstResponder' name='txtClinicalHomeFirstResponder' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Emergency Phone #:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Alternate Phone #:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEmergencyPhone' name='txtEmergencyPhone' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAlternatePhone' name='txtAlternatePhone' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>LME-MCO: Alliance</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>LME-MCO Phone #:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>County: Mecklenburg</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtLmeMcoAlliance' name='txtLmeMcoAlliance' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtLmeMcoPhoneNo' name='txtLmeMcoPhoneNo' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtCountyMecklenburg' name='txtCountyMecklenburg' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Clinical Home/First Responder: Carolinas Creative Counseling</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Living Situation (Stable, Unstable):</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If "Unstable" Describe:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtLivingSituationUnstable' name='txtLivingSituationUnstable' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDescribeUnstable' name='txtDescribeUnstable' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>In a crisis, assistance will be needed in the following areas (if not applicable, leave blank).</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Children (if yes, indicate ages):</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Pets (Yes/Blank):</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Transportation (Yes/Blank):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtChildrenIndicateAges' name='txtChildrenIndicateAges' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPetsBlank' name='txtPetsBlank' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTransportationYesBlank' name='txtTransportationYesBlank' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='Checkbox' id='cbOtherDescribeTheTypeOfAssistanceNeeded' name='cbOtherDescribeTheTypeOfAssistanceNeeded' className='add-only' value='OtherDescribe' /> Other (Describe the type of assistance needed):
                            <input type='text' id='txtOtherDescribeTheTypeOfAssistanceNeeded' name='txtOtherDescribeTheTypeOfAssistanceNeeded' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Explain what help will be needed:</span>
                    <textarea id="txtExplainWhatHelpWillBeNeeded" name="txtExplainWhatHelpWillBeNeeded" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>Employment (In a crisis, assistance will be needed to contact my employer)</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-280'>
                            <span className='eleHeader'>Assistance will be needed (Yes/No):</span>
                        </td>
                        <td className='w-225'>
                            <span className='eleHeader'>Contact Name:</span>
                        </td>
                        <td className='w-225'>
                            <span className='eleHeader'>Contact Phone #:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-280'>
                            <input type='text' id='txtAssistanceWillBeNeeded' name='txtAssistanceWillBeNeeded' className='add-only' />
                        </td>
                        <td className='w-225'>
                            <input type='text' id='txtContactName' name='txtContactName' className='add-only' />
                        </td>
                        <td className='w-225'>
                            <input type='text' id='txtContactPhone' name='txtContactPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please inform them: n/a </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPleaseInformThem' name='txtPleaseInformThem' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Communication</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Method (Verbal, Nonverbal, Picture System, Gestures, Sound/Gestures, Other Device):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtMethodVerbalNonverbalPictureSystemGesture' name='txtMethodVerbalNonverbalPictureSystemGesture' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='Checkbox' id='cbIfOtherSpecifyCommunication' name='cbIfOtherSpecifyCommunication' className='add-only' value='OtherDescribe' /> If "Other", specify:
                            <input type='text' id='txtIfOtherSpecifyCommunication' name='txtIfOtherSpecifyCommunication' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Preferred Language</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Preferred Language (English, Spanish, Sign Language, Other): English</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPreferredLanguageSignLanguageOtherEnglish' name='txtPreferredLanguageSignLanguageOtherEnglish' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='Checkbox' id='cbIfOtherSpecifyPreferredLanguage' name='cbIfOtherSpecifyPreferredLanguage' className='add-only' value='OtherDescribe' /> If "Other", specify:
                            <input type='text' id='txtIfOtherSpecifyPreferredLanguage' name='txtIfOtherSpecifyPreferredLanguage' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Legally Responsible Person</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Guardian Appointed (Yes/No):</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Legally Responsible Person Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact Phone #:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtGuardianAppointed' name='txtGuardianAppointed' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtLegallyResponsiblePersonName' name='txtLegallyResponsiblePersonName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactPhone' name='txtContactPhone' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Insurance</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Type of Insurance:</span>
                        </td>

                        <td className='w-375'>
                            <span className='eleHeader'>Policy Number/Member ID:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTypeOfInsurance' name='txtTypeOfInsurance' className='add-only' />
                        </td>

                        <td className='w-375'>
                            <input type='text' id='txtPolicyNumberMemberId' name='txtPolicyNumberMemberId' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Name of Company or Payer (If Type is Private or Other):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtNameOfCompanyPayerIfTypePrivateOrOther' name='txtNameOfCompanyPayerIfTypePrivateOrOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Diagnoses</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>DSM Code: F 91.3</span>
                        </td>

                        <td className='w-375'>
                            <span className='eleHeader'>Diagnosis: Oppositional defiant disorder</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Diagnosis Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='text' id='txtDsmCode_1' name='txtDsmCode_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDiagnosisOppositionalDefiantDisorder_1' name='txtDiagnosisOppositionalDefiantDisorder_1' className='add-only' />
                        </td>
                        <td className='w-187'><input type='date' id='txtDiagnosisDate_1' name='txtDiagnosisDate_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='text' id='txtDsmCode_2' name='txtDsmCode_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDiagnosisOppositionalDefiantDisorder_2' name='txtDiagnosisOppositionalDefiantDisorder_2' className='add-only' />
                        </td>
                        <td className='w-187'><input type='date' id='txtDiagnosisDate_2' name='txtDiagnosisDate_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='text' id='txtDsmCode_3' name='txtDsmCode_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDiagnosisOppositionalDefiantDisorder_3' name='txtDiagnosisOppositionalDefiantDisorder_3' className='add-only' />
                        </td>
                        <td className='w-187'><input type='date' id='txtDiagnosisDate_3' name='txtDiagnosisDate_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Current Medications (Update/revise anytime there is a change)</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Medication Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dose:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedicationName_1' name='txtMedicationName_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtDose_1' name='txtDose_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Reason for Change:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtReasonForChange_1' name='txtReasonForChange_1' className='add-only' />
                        </td>
                        <td className='w-250'><input type='date' id='txtReasonForChangeDate_1' name='txtReasonForChangeDate_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Prescribing MD:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Pharmacy:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPrescribing_1' name='txtPrescribing_1' className='add-only' />
                        </td>
                        <td className='w-375'><input type='text' id='txtPharmacy_1' name='txtPharmacy_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Medication Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dose:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedicationName_2' name='txtMedicationName_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtDose_2' name='txtDose_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Reason for Change:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtReasonForChange_2' name='txtReasonForChange_2' className='add-only' />
                        </td>
                        <td className='w-250'><input type='date' id='txtReasonForChangeDate_2' name='txtReasonForChangeDate_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Prescribing MD:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Pharmacy:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPrescribing_2' name='txtPrescribing_2' className='add-only' />
                        </td>
                        <td className='w-375'><input type='text' id='txtPharmacy_2' name='txtPharmacy_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Medication Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dose:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedicationName_3' name='txtMedicationName_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtDose_3' name='txtDose_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Reason for Change:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtReasonForChange_3' name='txtReasonForChange_3' className='add-only' />
                        </td>
                        <td className='w-250'><input type='date' id='txtReasonForChangeDate_3' name='txtReasonForChangeDate_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Prescribing MD:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Pharmacy:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPrescribing_3' name='txtPrescribing_3' className='add-only' />
                        </td>
                        <td className='w-375'><input type='text' id='txtPharmacy_3' name='txtPharmacy_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Allergies (Medication (s) and reaction - Update/revise anytime there is a change)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAllergiesMedicationAndReaction_1' name='txtAllergiesMedicationAndReaction_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAllergiesMedicationAndReaction_2' name='txtAllergiesMedicationAndReaction_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAllergiesMedicationAndReaction_3' name='txtAllergiesMedicationAndReaction_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtAllergiesMedicationAndReaction_4' name='txtAllergiesMedicationAndReaction_4' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Poorly Tolerated Medications (Medication(s) and reaction - Update/revise anytime there is a change)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPoorlyToleratedMedicationsAndReaction_1' name='txtPoorlyToleratedMedicationsAndReaction_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPoorlyToleratedMedicationsAndReaction_2' name='txtPoorlyToleratedMedicationsAndReaction_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPoorlyToleratedMedicationsAndReaction_3' name='txtPoorlyToleratedMedicationsAndReaction_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtPoorlyToleratedMedicationsAndReaction_4' name='txtPoorlyToleratedMedicationsAndReaction_4' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Medical/Dental Concerns</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtMedicalDentalConcerns_1' name='txtMedicalDentalConcerns_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtMedicalDentalConcerns_2' name='txtMedicalDentalConcerns_2' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <center><h3>Supports for The Individual</h3></center>
                </p>
                <p className='w-750'>
                    <center>Notification</center>
                </p>
                <p className='w-750'>
                    List the individuals that should be called in the event of a crisis, indicate the calling order, provide contact information, and indicate if a consent to release information to that person exists.
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>1. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_1' name='txtCallingOrder_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_1' name='txtWho_1' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_1' name='txtAgency_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_1' name='txtName_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_1' name='txtPhone_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_1' name='txtIsThereValidConsentRelease_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>2. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_2' name='txtCallingOrder_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_2' name='txtWho_2' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_2' name='txtAgency_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_2' name='txtName_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_2' name='txtAddress_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_2' name='txtPhone_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_2' name='txtIsThereValidConsentRelease_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>3. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_3' name='txtCallingOrder_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_3' name='txtWho_3' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_3' name='txtAgency_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_3' name='txtName_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_3' name='txtAddress_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_3' name='txtPhone_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_3' name='txtIsThereValidConsentRelease_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>4. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_4' name='txtCallingOrder_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_4' name='txtWho_4' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_4' name='txtAgency_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_4' name='txtName_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_4' name='txtAddress_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_4' name='txtPhone_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_4' name='txtIsThereValidConsentRelease_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>5. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_5' name='txtCallingOrder_5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_5' name='txtWho_5' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_5' name='txtAgency_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_5' name='txtName_5' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_5' name='txtAddress_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_5' name='txtPhone_5' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_5' name='txtIsThereValidConsentRelease_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>6. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_6' name='txtCallingOrder_6' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_6' name='txtWho_6' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_6' name='txtAgency_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_6' name='txtName_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_6' name='txtAddress_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_6' name='txtPhone_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_6' name='txtIsThereValidConsentRelease_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>7. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_7' name='txtCallingOrder_7' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_7' name='txtWho_7' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_7' name='txtAgency_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_7' name='txtName_7' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_7' name='txtAddress_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_7' name='txtPhone_7' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_7' name='txtIsThereValidConsentRelease_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>8. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_8' name='txtCallingOrder_8' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_8' name='txtWho_8' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_8' name='txtAgency_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_8' name='txtName_8' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_8' name='txtAddress_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_8' name='txtPhone_8' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_8' name='txtIsThereValidConsentRelease_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>9. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_9' name='txtCallingOrder_9' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_9' name='txtWho_9' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_9' name='txtAgency_9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_9' name='txtName_9' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_9' name='txtAddress_9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_9' name='txtPhone_9' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_9' name='txtIsThereValidConsentRelease_9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>10. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_10' name='txtCallingOrder_10' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_10' name='txtWho_10' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_10' name='txtAgency_10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_10' name='txtName_10' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_10' name='txtAddress_10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_10' name='txtPhone_10' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_10' name='txtIsThereValidConsentRelease_10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>11. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_11' name='txtCallingOrder_11' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_11' name='txtWho_11' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_11' name='txtAgency_11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_11' name='txtName_11' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_11' name='txtAddress_11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_11' name='txtPhone_11' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_11' name='txtIsThereValidConsentRelease_11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>12. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_12' name='txtCallingOrder_12' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_12' name='txtWho_12' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_12' name='txtAgency_12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_12' name='txtName_12' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_12' name='txtAddress_12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_12' name='txtPhone_12' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_12' name='txtIsThereValidConsentRelease_12' className='add-only' />
                        </td>
                    </tr><tr>
                        <td className='w-150'>
                            <span className='eleHeader'>13. Calling Order</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Who</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Agency</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCallingOrder_13' name='txtCallingOrder_13' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtWho_13' name='txtWho_13' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtAgency_13' name='txtAgency_13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_13' name='txtName_13' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_13' name='txtAddress_13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is there a valid consent to release (Yes/No)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_13' name='txtPhone_13' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtIsThereValidConsentRelease_13' name='txtIsThereValidConsentRelease_13' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <center><h3>Crisis Follow Up Planning</h3>
                        <span className='small'>(Include contact number(s) if not provided above)</span></center>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>Who is the primary contact to coordinate care if the individual requires inpatient or other specialized care?</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact #</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact #</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName_13' name='txtName_13' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContact_13' name='txtContact_13' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactSeries_13' name='txtContactSeries_13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Who will visit the individual while hospitalized? (This information should come from the individual and reflect the individual's preference)</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact #</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact #</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName_14' name='txtName_14' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContact_14' name='txtContact_14' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactSeries_14' name='txtContactSeries_14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Who will lead a review/debriefing following a crisis? Within what timeframe?</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Timeframe</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_15' name='txtName_15' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtTimeFrame_15' name='txtTimeFrame_15' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <center><h3>Additional Planning Documents	</h3>
                        <span className='small'>(Indicate if the individual has any of the following documents. If "Yes", attach the document to the Crisis Plan)</span></center>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Individual Behavior Plan</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtIndividualBehaviorPlan' name='txtIndividualBehaviorPlan' className='add-only' placeholder='Yes/No' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtIndividualBehaviorPlanNotes' name='txtIndividualBehaviorPlanNotes' className='add-only' placeholder='Notes' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicide Prevention and Intervention Plan</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtSuicidePreventionAndInterventionPlan' name='txtSuicidePreventionAndInterventionPlan' className='add-only' placeholder='Yes/No' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtSuicidePreventionAndInterventionPlanNotes' name='txtSuicidePreventionAndInterventionPlanNotes' className='add-only' placeholder='Notes' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>WRAP Plan</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtWrapPlan' name='txtWrapPlan' className='add-only' placeholder='Yes/No' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtWrapPlanNotes' name='txtWrapPlanNotes' className='add-only' placeholder='Notes' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Futures Plan (youth in transition/young adult)	No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtFuturesPlanYouthTransitionYoungAdultNo' name='txtFuturesPlanYouthTransitionYoungAdultNo' className='add-only' placeholder='Yes/No' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtFuturesPlanYouthTransitionYoungAdultNoNotes' name='txtFuturesPlanYouthTransitionYoungAdultNoNotes' className='add-only' placeholder='Notes' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Psychiatric Advance Directive (PAD).</span>
                            <span className='small'>A PAD is a legal document allowing a member to direct his or her psychiatric treatment in the event that he or she becomes unable to make or communicate decisions about that treatment. To find out more information about PADs in North Carolina, go to <a href='http://www.nrc-pad.org/states/north-carolina-resources.'> http://www.nrc-pad.org/states/north-carolina-resources. </a></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPsychiatricAdvanceDirective' name='txtPsychiatricAdvanceDirective' className='add-only' placeholder='Yes/No' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtPsychiatricAdvanceDirectiveNotes' name='txtPsychiatricAdvanceDirectiveNotes' className='add-only' placeholder='Notes' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other Advance Directive or Living Will</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtOtherAdvanceDirectiveOrLivingWill' name='txtOtherAdvanceDirectiveOrLivingWill' className='add-only' placeholder='Yes/No' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtOtherAdvanceDirectiveOrLivingWillNotes' name='txtOtherAdvanceDirectiveOrLivingWillNotes' className='add-only' placeholder='Notes' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>General Characteristics/Preferences - as described in the individual's own words</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What am I like when I am feeling well? </span>
                    <span className='small'>Describe what a good day looks like for this person. Provide examples of how s/he interacts, behaves, appears, and feels when s/he has an overall sense of wellness and wellbeing.</span>
                    <textarea id="txtWhatAmLikeFeelingWell" name="txtWhatAmLikeFeelingWell" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are some events or situations that have caused me trouble in the past?</span>
                    <span className='small'>Outline significant events that may create or increase stress and trigger the onset of a crisis. (Examples: anniversaries, holidays, noise, change in routine, inability to express medical problems or to get needs met, out of medication, being isolated, etc.)</span>
                    <textarea id="txtWhatSomeEventsSituationHaveCausedTrouble" name="txtWhatSomeEventsSituationHaveCausedTrouble" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are the early warning signs that I am not doing well? What will others notice about my behavior, speech, and actions when I am not doing well?</span>
                    <span className='small'>Describe what others observe when s/he is entering a crisis episode. Include lessons learned from previous crisis events. (Examples: not keeping appointments, isolating himself, loud or hyper-verbal speech, not sleeping well, eating too much, etc.)</span>
                    <textarea id="txtWhatAreWarningSignsDoingWell" name="txtWhatAreWarningSignsDoingWell" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>How can others help me and what can I do to help myself to address a crisis early on? Who is best able to assist me?</span>
                    <span className='small'>Describe prevention and intervention strategies that have been effective in reducing stress, problem solving, and keeping the person from needing higher levels of care such as a trip to an emergency department or crisis center or inpatient hospitalization. (Examples: breathing exercises, journaling, taking a walk, listening to music, calling a friend or family member or provider, etc.)</span>
                    <textarea id="txtHowCanOtherHelpMeWhatHelpMyself" name="txtHowCanOtherHelpMeWhatHelpMyself" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If I am in crisis, what are ways that others can help me and how can I help myself? What strategies do not work well for me?</span>
                    <span className='small'>List everything that has worked well for the person in the past. Focus first on the least restrictive steps including natural and community supports. Describe how crisis staff should interact with the person in crisis. Describe preferred and non-preferred medications, treatment facilities, and options for respite. Include the person's preferred process for obtaining back-up in case of emergency. (Examples: I like music, I like to go for a walk, I like to be talked to, call my sponsor, remind me of my PRN meds, I do not like to be talked to, I don't like to be touched, I prefer ABC hospital over XYZ hospital, etc.)</span>
                    <textarea id="txtCrisisWhatWaysThatOthersHelpAndHowStrategies" name="txtCrisisWhatWaysThatOthersHelpAndHowStrategies" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>PLAN SIGNATURES</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>I.	PERSON RECEIVING SERVICES:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPlanSignaturesConfirmAndAgree' name='cbPlanSignaturesConfirmAndAgree' className='add-only' value='PlanSignaturesConfirmAndAgree' /> I confirm and agree with my involvement in the development of this PCP.  My signature means that I agree with the services/supports to be provided. </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbUnderstandChoiceServiceProviderChangeService' name='cbUnderstandChoiceServiceProviderChangeService' className='add-only' value='IllegalDrugUse' /> I understand that I have the choice of service providers and may change service providers at any time, by contacting the person responsible for this PCP.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbConfirmAndUnderstandThatHaveChoiceSeeking' name='cbConfirmAndUnderstandThatHaveChoiceSeeking' className='add-only' value='InjectedDrugUse' /> For I/DD services only, I confirm and understand that I have the choice of seeking care in an intermediate care facility for individuals with Intellectual/Developmental Disabilities (I/DD) instead of participating in the Community Alternatives Program for individuals with Intellectual/Developmental Disabilities (I/DD).</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Legally Responsible Person:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Self:</b> &nbsp;
                            <input type='radio' id='rbLegallyResponsiblePersonYes' name='rbLegallyResponsiblePerson' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLegallyResponsiblePersonNo' name='rbLegallyResponsiblePerson' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Person Receiving Services:</span>
                            <span className='small'>(Required when person is his/her own legally responsible person)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Signature</td>
                        <td className='small w-250'> (Print Name) </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Legally Responsible Person</span>
                            <span className='small'>(Required if other than person receiving Services)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>

                    </tr>
                    <tr>
                        <td className='small w-375'> Signature</td>
                        <td className='small w-375'> (Print Name) </td>

                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Relationship to the Individual: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>II.      PERSON RESPONSIBLE FOR THE PCP:</span>
                            <span className='small'>The following signature confirms the responsibility of the QP/LP for the development of this PCP.  The signature indicates agreement with the services/supports to be provided</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Signature :</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'>(Person responsible for the PCP)</td>
                        <td className='small w-250'>(Name of Case Management Agency)</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Child Mental Health Services Only:</span>
                            <span className='small'>For individuals who are less than 21 years of age (less than 18 for State funded services) and who are receiving or in need of enhanced services and who are actively involved with the Department of Juvenile Justice and Delinquency Prevention or the adult criminal court system, the person responsible for the PCP must attest that he or she has completed the following requirements as specified below:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='checkbox' id='cbMetWithChildFamilyTeam' name='cbMetWithChildFamilyTeam' className='add-only' value='MetWithChildFamilyTeam' /> Met with the Child and Family Team - </td>
                        <td className='w-150'><input type='date' id='txtDateMetWithChildFamilyTeam' name='txtDateMetWithChildFamilyTeam' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='checkbox' id='cbChildFamilyTeamMeetingScheduleFor' name='cbChildFamilyTeamMeetingScheduleFor' className='add-only' value='ChildFamilyTeamMeetingScheduleFor' /> OR Child and Family Team meeting scheduled for - </td>
                        <td className='w-150'><input type='date' id='txtDateChildFamilyTeamMeetingScheduleFor' name='txtDateChildFamilyTeamMeetingScheduleFor' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-600'><input type='checkbox' id='cbAssignedTascCareManager' name='cbAssignedTascCareManager' className='add-only' value='AssignedTascCareManager' /> OR Assigned a TASC Care Manager  - </td>
                        <td className='w-150'><input type='date' id='txtDateAssignedTascCareManager' name='txtDateAssignedTascCareManager' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbConferredWithTheClinicalStaffOfTheApplicableConductCareCoordination' name='cbConferredWithTheClinicalStaffOfTheApplicableConductCareCoordination' className='add-only' value='ConferredWithTheClinicalStaffOfTheApplicableConductCareCoordination' /> AND conferred with the clinical staff of the applicable LME to conduct care coordination </td>
                    </tr>
                    <tr>
                        <td className='W-750'>
                            <b>If the statements above do not apply, please check the box below and then sign as the Person Responsible for the PCP:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbThisChildIsNotActivelyInvolvedWithTheDepartmentOfJuvenileJusticeAndPreventionTheAdultCriminalCourtSystem' name='cbThisChildIsNotActivelyInvolvedWithTheDepartmentOfJuvenileJusticeAndPreventionTheAdultCriminalCourtSystem' className='add-only' value='ThisChildIsNotActivelyInvolvedWithTheDepartmentOfJuvenileJusticeAndPreventionTheAdultCriminalCourtSystem' /> This child is not actively involved with the Department of Juvenile Justice and Prevention or the adult criminal court system </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Signature :</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'>(Person responsible for the PCP)</td>
                        <td className='small w-250'>(Print Name)</td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>III.   SERVICE ORDERS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>(SECTION A):</b>
                            <span className='small'> For services ordered by one of the Medicaid approved licensed signatories (see Instruction Manual).</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>My signature below confirms the following: (Check all appropriate boxes.)</b>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <ul>
                        <li className='w-750'> Medical necessity for services requested is present and constitutes the Service Order(s).</li>
                        <li className='w-700'> The licensed professional who signs this service order has had direct contact with the individual &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbLicensedProfessionalSignsServiceOrderDirectContactYes' name='rbLicensedProfessionalSignsServiceOrderDirectContact' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLicensedProfessionalSignsServiceOrderDirectContactNo' name='rbLicensedProfessionalSignsServiceOrderDirectContact' className='add-only' value='No' /> No
                        </li>
                        <li className='w-700'>	The licensed professional who signs this service order has reviewed the individual's assessment &nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbLicensedProfessionalSignsServiceOrderReviewedIndividualAssessmentYes' name='rbLicensedProfessionalSignsServiceOrderReviewedIndividualAssessment' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLicensedProfessionalSignsServiceOrderReviewedIndividualAssessmentNo' name='rbLicensedProfessionalSignsServiceOrderReviewedIndividualAssessment' className='add-only' value='No' /> No
                        </li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>Signature :</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>

                    </tr>
                    <tr>
                        <td className='small w-375'> (Name/Title Required)</td>
                        <td className='small w-375'> (Print Name) </td>

                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> License #:</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>(SECTION B):</b>
                            <span className='small'> For Qualified Professionals (QP) / Licensed Professionals (LP) ordering:</span>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <ul>
                        <li className='w-750'> I/DD or </li>
                        <li className='w-750'> Medicaid Tailored Care Management (TCM) services (if not ordered in Section A)
                        </li>
                        <li className='w-750'> Any state-funded services not ordered in Section A or
                        </li>
                        <li className='w-750'> 1915 i Option service(s) (if not ordered in Section A)
                        </li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>My signature below confirms the following: </b>
                            <span className='small'> (Check all appropriate boxes.) Signatory in this section must be a Qualified or Licensed Professional. </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMedicalNecessityIddServicesRequestedPresentconstitutesServiceOrder' name='cbMedicalNecessityIddServicesRequestedPresentconstitutesServiceOrder' className='add-only' value='MedicalNecessityIddServicesRequestedPresentconstitutesServiceOrder' /> Medical necessity for the I/DD services requested is present and constitutes the Service Order. </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMedicalNecessityForTheMedicaidTcmservicrequestedIsPresentAndConstitutesTheServiceOrder' name='cbMedicalNecessityForTheMedicaidTcmservicrequestedIsPresentAndConstitutesTheServiceOrder' className='add-only' value='MedicalNecessityForTheMedicaidTcmservicrequestedIsPresentAndConstitutesTheServiceOrder' /> Medical necessity for the Medicaid TCM service requested is present and constitutes the Service Order. </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMedicalNecessityForTheStateFundedServiceRequestedIsPresentAndConstitutesTheServiceOrder' name='cbMedicalNecessityForTheStateFundedServiceRequestedIsPresentAndConstitutesTheServiceOrder' className='add-only' value='MedicalNecessityForTheStateFundedServiceRequestedIsPresentAndConstitutesTheServiceOrder' /> Medical necessity for the State-funded service(s) requested is present, and constitutes the Service Order. </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMedicalOptionServiceRequestedPresentConstitutesServiceOrder' name='cbMedicalOptionServiceRequestedPresentConstitutesServiceOrder' className='add-only' value='MedicalOptionServiceRequestedPresentConstitutesServiceOrder' /> Medical necessity for the 1915(i) Option service(s) requested is present and constitutes the Service Order.</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Signature :</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>

                    </tr>
                    <tr>
                        <td className='small w-375'> (Name/Title Required)</td>
                        <td className='small w-375'> (Print Name) </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>License #: </b>
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>

                    </tr>
                    <tr>
                        <td className='small w-375'> (If Applicable)</td>
                        <td className='small w-375'> Date </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>IV.	 SIGNATURES OF OTHER TEAM MEMBERS PARTICIPATING IN DEVELOPMENT OF THE PLAN:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>

                    </tr>
                    <tr>
                        <td className='small w-375'>Other Team Member (Name/Relationship):</td>
                        <td className='small w-375'> Date </td>

                    </tr>
                </table>

            </div>
        </form>

    )
}











